import { CONTRACTOR_LOCATIONS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/contractor_locations_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'contractorLocationsIndex',
	'WORK_ORDER_FORM_LOCATIONS_AUTOCOMPLETE',
	'workOrdersAdvancedFilters',
	'CONTRACTOR_WO_EDIT_AUTOCOMPLETE',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
